import axios from 'axios';
import { User } from 'oidc-client';
import { AuthService, BuddiService } from './';
import * as Constants from '../utils/constants';

type SyncResult = {
  name: string;
  instanceId: string;
  runtimeStatus: 'Completed' | 'Running' | 'Failed';
  output: SyncStatus;
};

type SyncStatus = {
  UserHasPermission: boolean;
};

type SyncJob = {
  id: string;
  statusQueryGetUri: string;
  sendEventPostUri: string;
  terminatePostUri: string;
  purgeHistoryDeleteUri: string;
};

export async function syncUserToProject(
  contextId: string,
  pollInterval = 5000
): Promise<boolean> {
  const syncJob = await getSyncJob(
    await AuthService.getUser(),
    await AuthService.getUser('pwdi'),
    contextId
  );
  if (!syncJob) {
    return false;
  }

  const statusQueryUri = syncJob.statusQueryGetUri;
  let syncStatus = await getSyncStatus(statusQueryUri);
  while (syncStatus.runtimeStatus === 'Running') {
    await new Promise(resolve => setTimeout(resolve, pollInterval));
    syncStatus = await getSyncStatus(statusQueryUri);
  }

  if (syncStatus.runtimeStatus === 'Completed') {
    return syncStatus.output.UserHasPermission;
  }

  return false;
}

async function getSyncJob(
  user: User,
  pwdiUser: User,
  contextId: string
): Promise<SyncJob | undefined> {
  const serviceUrl = await BuddiService.getUrl(Constants.Buddi.userSync);
  const url = `${serviceUrl}/api/usersync/context/${contextId}/user/${user.profile.sub}`;

  try {
    const response = await axios.post<SyncJob>(url, undefined, {
      headers: {
        Authorization: `${pwdiUser.token_type} ${pwdiUser.access_token}`,
      },
    });
    return response.data;
  } catch {
    return undefined;
  }
}

async function getSyncStatus(statusQueryUri: string): Promise<SyncResult> {
  return (await axios.get<SyncResult>(statusQueryUri)).data;
}
